<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TimeOffBase from '../../../../../time-off/components/TimeOffBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <TimeOffBase />
</template>